<script setup lang="ts">
import { onMounted } from 'vue'
import ProgressSpinner from 'primevue/progressspinner'
import { announce } from '@/util/live_announcer'

onMounted(() => announce('Loading subject summary...'))
</script>

<template>
  <div class="flex flex-col items-center justify-center h-80 bg-blue-200 rounded-md font-default text-md mb-3" role="status" aria-live="polite">
    <div class="flex items-center justify-center">
      <ProgressSpinner strokeWidth="4" class="h-8 w-8 stroke-blue-500" />
    </div>
    <div class="text-base-defaultText mt-4">Loading...</div>
  </div>
</template>
